/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentStatuses {
    '_1' = 1,
    '_2' = 2,
}
